import React, { Component } from 'react';
import LoadingSpinner from './common/LoadingSpinner.js';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

class Wizard extends Component {
  static Page = ({ children }) => children;

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      values: props.initialValues,
    };
  }

  next = (values) => {
    this.setState((state) => ({
      page: Math.min(state.page + 1, this.props.children.length - 1),
      values
    }))
  }

  previous = (setFieldValue) => {
    setFieldValue("newPassword", "");
    setFieldValue("newPasswordConfirm", "");
    this.setState((state) => ({page: Math.max(state.page - 1, 0)}));
  }

  handleSubmit = (values, actions) => {
    const {children, onSubmit } = this.props;
    const { page } = this.state;
    const isLastPage = page === React.Children.count(children) - 1;
    if (isLastPage) {
      return onSubmit(values, actions);
    } else {
      this.next(values);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  render() {
    const { children } = this.props;
    const { page, values } = this.state;
    const activePage = React.Children.toArray(children)[page];
    const isLastPage = page === React.Children.count(children) - 1;

    return (
      <Formik initialValues={values} onSubmit={this.handleSubmit} validationSchema={activePage.props.validate}>
      {
        ({ values, handleSubmit, isSubmitting, handleReset, setFieldValue}) => {
          return (
            <form className="login100-form validate-form flex-sb flex-w" onSubmit={handleSubmit}>
              {activePage}
              <div className="row" style={{width: "100%", margin: "0px"}}>
                <div className="col-md-6">
                  <button 
                    type="button"
                    className="btn btn-light"
                    style={{margin: "0px", width: "100%"}}
                    disabled={page <= 0}
                    onClick={() => this.previous(setFieldValue)}
                  >
                    Previous
                  </button>
                </div>

                <div className="col-md-6">
                  <button 
                    type="submit"
                    className="btn btn-primary"
                    style={{margin: "0px", width: "100%"}}
                  >
                    {isLastPage ? "Verify" : "Next"}
                  </button>
                </div>
              </div>
            </form>
          )
        }
      }
      </Formik>
    )
  }
}

class VerifyUser extends Component {

  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        newPassword: "",
        newPasswordConfirm: "",
        code: "",
        encrypted: decodeURIComponent(this.props.match.params.query)
      },      
      loading: true
    }
  }

  componentDidMount() {
    this.getQrImage();
  }

  getQrImage = () => {
    fetch('/api/getNewQr', {
      method: "POST",
      body: JSON.stringify({encrypted: this.state.initialValues.encrypted}),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    }).then(r =>  r.json().then(data => ({res: r, body: data})))
    .then(obj => {
      if(!obj.res.ok) throw Error(obj.res.statusText);
      else{
        if(obj.body === undefined || obj.body === null) console.log("No QR data to display");
        else this.setState({qrsrc: obj.body});
      }
    })
    .catch(function(error) {
      window.location = '/';
    })
    .then(() => this.setState({loading: false}));
  }

  submit = (values, actions) => {
    fetch('/api/verifyUser', {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin"
    })
    .then((res) => {
      if(!res.ok){
        if(res.status === 401) actions.setFieldError("code", "Incorrect Code")
        else if (res.status === 400) window.location = '/';
        else{
          alert("User could not be verified");
          throw Error(res.statusText);
        }
      }
      else{
        alert("Successfully Verified!");
        window.location = '/';
      }
    }).catch(function(error) {
      console.log(error);
    })
    .then(() => {
      actions.setSubmitting(false);
      actions.setFieldValue("code", "", false);
    })
  }

  validateOne = () => {
    return Yup.object()
      .shape({
        newPassword: Yup.string()
          .required("Required!")
          .min(8, "Too short!")
          .max(128, "Too long!"),
        newPasswordConfirm: Yup.string().ensure()
          .when('newPassword', {
            is: (newPassword) => newPassword,
            then: Yup.string().oneOf([Yup.ref("newPassword")], "Passwords do not match"),
            otherwise: null
          })
      })
  }

  validateTwo = () => {
    return Yup.object()
      .shape({
        code: Yup.string()
          .required("Required!")
          .matches(/^\d+$/, "Numbers only!")
          .min(6, "Code must be 6 digits long!")
          .max(6, "Code must be 6 digits long!")
      })
  }

  render() {
    if (this.state.loading) {
      return <LoadingSpinner />
    }

    return (
      <div id = "wrapper">
        <div className="limiter">
          <div className="container-login100">
            <div className="wrap-login100 p-l-85 p-r-85 p-t-55 p-b-55">
              <Wizard initialValues={this.state.initialValues} onSubmit={this.submit}>
                <Wizard.Page validate={this.validateOne()}>
                  <div className="m-b-36" style={{width: "100%"}}>
                    <span className="txt1 m-b-11" style={{display: "block"}}>
                      New Password
                    </span>
                    <div className="wrap-input100 validate-input">
                      <Field autoFocus className="input100" type="password" name="newPassword" />
                      <span className="focus-input100"></span>
                    </div>
                    <ErrorMessage name="newPassword" component="div" style={{display: "block"}} className="errorMessage"/>
                  </div>

                  <div className="m-b-36" style={{width: "100%"}}>
                    <span className="txt1 p-b-11" style={{display: "block"}}>
                      Confirm Password
                    </span>
                    <div className="wrap-input100 validate-input">
                      <Field className="input100" type="password" name="newPasswordConfirm" />
                      <span className="focus-input100"></span>
                    </div>
                    <ErrorMessage name="newPasswordConfirm" component="div" style={{display: "block"}} className="errorMessage"/>
                  </div>
                </Wizard.Page>

                <Wizard.Page validate={this.validateTwo()}>
                  <span style={{display: "block", width: "100%", padding: "0px 0px 20px 0px"}}>
                    <img height="100%" alt="Authenticator QR" src={this.state.qrsrc} style={{width: "60%", marginLeft: "20%"}}></img>
                  </span>

                  <div className="m-b-36" style={{width: "100%"}}>
                    <span className="txt1 p-b-11" style={{display: "block"}}>
                      Google Authentication Code
                    </span>
                    <div className="wrap-input100 validate-input">
                      <Field className="input100" type="text" name="code" autoComplete="off" />
                      <span className="focus-input100"></span>
                    </div>
                    <ErrorMessage name="code" component="div" style={{display: "block"}} className="errorMessage"/>
                  </div>

                  <div className="flex-sb-m w-full p-b-48">
                    <span className="txt3" onClick = {this.forgotPasswordClicked}>
                      <p>Instructions: </p>
                      <ol style={{listStyleType: "decimal"}}>
                        <li>Download Google Authenticator app on your smartphone</li>
                        <li>Scan the QR code using the Google Authenticator app</li>
                        <li>Enter the 6 digit Google Authenticator Code above</li>
                      </ol>
                    </span>
                  </div>
                </Wizard.Page>
              </Wizard>
            </div>
          </div>
        </div>
        <div id="dropDownSelect1"></div>
      </div>
    )
  }
}

export default VerifyUser;


// WEBPACK FOOTER //
// ./src/Components/VerifyUser.js